import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3c-.405 0-.7.317-.7.667v7.222a1 1 0 1 1-2 0V4.778a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v9.444a1 1 0 1 1-2 0v-2.778a.684.684 0 0 0-.7-.666c-.405 0-.7.317-.7.666v2.223C4.5 17.698 7.84 21 12 21s7.5-3.302 7.5-7.333V8.11a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v2.778a1 1 0 1 1-2 0V4.778a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v6.11a1 1 0 1 1-2 0V3.668A.684.684 0 0 0 12 3Zm2.336-.673A2.712 2.712 0 0 0 12 1c-.988 0-1.865.529-2.336 1.327A2.72 2.72 0 0 0 8.6 2.11c-1.472 0-2.7 1.175-2.7 2.667v4.09a2.728 2.728 0 0 0-.7-.09c-1.472 0-2.7 1.175-2.7 2.666v2.223C2.5 18.84 6.772 23 12 23s9.5-4.16 9.5-9.333V8.11c0-1.491-1.228-2.667-2.7-2.667-.241 0-.476.032-.7.091v-.757c0-1.492-1.228-2.667-2.7-2.667a2.72 2.72 0 0 0-1.064.216Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgHand.displayName = 'Hand';
export default SvgHand;
